// ./src/contect/authReducer.js

const authReducer = (state, {type, payload}) => {

    switch(type){
        case 'LOGIN_SUCCESS':
            let {email, id, name, photo, role} = payload; 
            return {
                ...state,
                isLoggedIn: true,
                authData: payload
                // authData: { email: email, id: id, name: name, photo: photo, role }
            };

        case 'LOGOUT':
            localStorage.removeItem('userRole');
            // localStorage.removeItem('user');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('googleToken');
            console.log("User information is removed");    
            return {
                ...state,
                isLoggedIn: false
            }

        // case 'UPDATE':
        //     return {
        //         ...state,
        //         isLoggedIn: true,
        //         authData: payload
        //     };
        case 'UPDATE':
            return {
                ...state,
                isLoggedIn: true,
                authData: {
                ...state.authData,  // ✅ Keep existing fields (including id!)
                ...payload          // ✅ Add/override with new fields (like role)
                }
            };
       
        default:
            return state;
    }
};

export default authReducer;